import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/pc/home",
  },
  {
    path: "/pc/home",
    name: "home",
    component: () => import("../views/pc/home.vue"),
  },

  {
    path: "/app/home",
    name: "homea",
    component: () => import("../views/app/home.vue"),
  },
  {
    path: "/app/verify",
    name: "verify",
    component: () => import("@/views/app/verify.vue"),
  },
  {
    path: "/pc/verify",
    name: "verify",
    component: () => import("@/views/pc/verify.vue"),
  },
  {
    path: "/app/brandhistory",
    name: "brandhistory",
    component: () => import("../views/app/brandhistory.vue"),
  },
  {
    path: "/pc/brandhistory",
    name: "brandhistory",
    component: () => import("../views/pc/brandhistory.vue"),
  },
  {
    path: "/app/detail",
    name: "detail",
    component: () => import("@/views/app/detail.vue"),
  },
    {
    path: "/app/goodInfo",
    name: "goodInfo",
    component: () => import("@/views/app/goodInfo.vue"),
  },
  {
    path: "/pc/detail",
    name: "detail",
    component: () => import("@/views/pc/detail.vue"),
  },
    {
    path: "/pc/goodInfo",
    name: "goodInfo",
    component: () => import("@/views/pc/goodInfo.vue"),
  },
  {
    path: "/app/entry",
    name: "entry",
    component: () => import("@/views/app/entry.vue"),
  },
  {
    path: "/pc/entry",
    name: "entry",
    component: () => import("@/views/pc/entry.vue"),
  },
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // console.log("查看跳转", to);
  let isMobile = store.state.isMobile;
  
  if (isMobile) {
    if (to.fullPath.indexOf("/app") >= 0) {
      next();
    } else {
      next("/app" + to.fullPath.replace("/pc", ""));
    }
  } else {
    if (to.name == "home") {
      localStorage.setItem("keyPath", "1");
    } else if (to.name == "verify") {
      localStorage.setItem("keyPath", "2");
    } else if (to.name == "brandhistory") {
      localStorage.setItem("keyPath", "3");
    } else if (to.name == "entry") {
      localStorage.setItem("keyPath", "4");
    }
    if (to.fullPath.indexOf("/pc") >= 0) {
      next();
    } else {
      next("/pc" + to.fullPath.replace("/app", ""));
    }
  }
});

export default router;
